module.exports = __webpack_public_path__ + "img/COMBO RADIO LIME.153f66c.svg";